import CurrencyEnum from 'enums/currency.enum'
import CountryEnum from 'enums/country.enum'

export default {
    computed: {
        regularYearly() {
            return this.countryName === CountryEnum.SERBIA
                ? process.env.VUE_APP_PACKAGE_REGULAR_YEARLY
                : process.env.VUE_APP_PACKAGE_REGULAR_YEARLY_BAM
        },
        regularMonthly() {
            return this.countryName === CountryEnum.SERBIA
                ? process.env.VUE_APP_PACKAGE_REGULAR
                : process.env.VUE_APP_PACKAGE_REGULAR_BAM
        },
        subdomainYearly() {
            return this.countryName === CountryEnum.SERBIA
                ? process.env.VUE_APP_PACKAGE_SUBDOMAIN_YEARLY
                : process.env.VUE_APP_PACKAGE_SUBDOMAIN_YEARLY_BAM
        },
        subdomainMonthly() {
            return this.countryName === CountryEnum.SERBIA
                ? process.env.VUE_APP_PACKAGE_SUBDOMAIN
                : process.env.VUE_APP_PACKAGE_SUBDOMAIN_BAM
        },
        currency() {
            return this.countryName === CountryEnum.SERBIA
                ? `${CurrencyEnum.RSD} ${this.$t('pages.company.custom_reminders.pdv_include_message')}`
                : CurrencyEnum.BAM
        },
    },
}
